import styled from "@emotion/styled";

export const StyledSubscriptions = styled.div`
  .loading {
    height: 100dvh;
  }
  .not-owner {
    width: 100%;
    height: 100dvh;
    .ant-empty {
      max-width: 600px;
    }
  }
`;
